import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DesignatedUnitGeneralDetailsFormGroup } from '../../../../../employers/add-employer/forms/designated-unit-general-details-form-group';
import { DropDownItem } from '../../../../../../models/shared/stylesheet/drop-down-item';

@Component({
  selector: 'app-create-designated-unit-general-details-about-section',
  templateUrl: './designated-unit-about-section.component.html',
  styleUrls: ['./designated-unit-about-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateDesignatedUnitGeneralDetailsAboutSectionComponent {
  @Input() formGroup!: DesignatedUnitGeneralDetailsFormGroup;
  @Input() formSubmitted: boolean = false;
  @Input() designatedUnitTypeDropdowns: DropDownItem[] = [];
  @Input() remittanceFrequencyDropdowns: DropDownItem[] = [];

  public customErrorMessages = {
    unitName: {
      required: $localize`Unit Name required`,
      duplicateDesignatedUnitName: $localize`This name is already in use`
    },
    clientUnitId: {
      required: $localize`Unit ID required`,
      duplicateClientUnitId: $localize`Unit ID must be unique`
    },
    designatedUnitTypeId: {
      required: $localize`Category required`
    },
    remittanceFrequencyTypeId: {
      required: $localize`Remittance Frequency required`
    }
  };
}
